import { render, staticRenderFns } from "./ContestFaqOrderComponent.vue?vue&type=template&id=fb3f7f9e"
import script from "./ContestFaqOrderComponent.vue?vue&type=script&lang=js"
export * from "./ContestFaqOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports